import component from '@123/druid/dist/Framework/Decorators/Component';
import {inject} from '@123/druid/dist/Framework/Decorators/Inject';
import onClick from '@123/druid/dist/Framework/Decorators/OnClick';
import prop from '@123/druid/dist/Framework/Decorators/Prop';
import View from '@123/druid/dist/Framework/View/View';
import DialogFactory from '@Component/Window/DialogFactory';
import NewsService from '@Module/News/Service/NewsService';

@component
export default class NewsItemView extends View {
    @prop private newsItemId?: number;

    constructor(@inject(NewsService) private newsService: NewsService) {
        super();
    }

    @onClick('news-item-link')
    protected async clickLink(): Promise<void> {
        if (this.newsItemId === undefined) {
            return;
        }

        const {html, title} = await this.newsService.getNewsItem(this.newsItemId);

        await DialogFactory.contentDialog(html, title);
    }
}
